// src/components/MobileMenu/MobileMenu.js

import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
  {
    id: 1,
    title: 'Trang chủ',
    link: '/'
  },
  {
    id: 2,
    title: 'Hướng dẫn',
    link: '/huongdan'
  },
  {
    id: 3,
    title: 'Công cụ AI',
    submenu: [
      { title: 'Thiết kế cùng AI', link: '/image-generate' },
      { title: 'AI nhận diện', link: '/image-ai' }
    ]
  },
  {
    id: 4,
    title: '360',
    link: '/vr'
  },
  {
    id: 5,
    title: 'Sản phẩm',
    link: '/sanpham'
  },
  {
    id: 6,
    title: 'Trắc nghiệm',
    link: '/tracnghiem'
  },
  {
    id: 7,
    title: 'Tin tức',
    submenu: [
      { title: 'Bài nghiên cứu', link: '/blog' },
      { title: 'Khoảnh khắc', link: '/gallery' },
      { title: 'Liên hệ', link: '/contact' }
    ]
  }
];

const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    // Hàm này để cuộn lên đầu trang, giữ lại nếu cần
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    // Hàm xử lý khi click vào link (đóng menu)
    const handleLinkClick = () => {
        ClickHandler(); // Cuộn lên đầu trang
        setMenuState(false); // Đóng menu
    };

    // Hàm xử lý khi click vào link ngoài (chỉ đóng menu)
    const handleExternalLinkClick = () => {
        setMenuState(false); // Đóng menu
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ? // Kiểm tra nếu có submenu (dù hiện tại không có)
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                            {item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => (
                                                        <ListItem key={i}>
                                                            <NavLink
                                                                // Bỏ className="active" cứng ở đây, NavLink tự xử lý active class
                                                                to={submenu.link}
                                                                onClick={handleLinkClick} // Đóng menu khi click submenu
                                                            >
                                                                {submenu.title}
                                                            </NavLink>
                                                        </ListItem>
                                                    ))}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : // Nếu không có submenu
                                    item.isExternal ? // Kiểm tra nếu là link ngoài
                                    <a
                                        href={item.link}
                                        target="_blank" // Mở tab mới cho link ngoài
                                        rel="noopener noreferrer"
                                        onClick={handleExternalLinkClick} // Đóng menu khi click link ngoài
                                    >
                                        {item.title}
                                    </a>
                                    : // Nếu là link nội bộ
                                    <NavLink
                                        // Bỏ className="active" cứng ở đây, NavLink tự xử lý active class
                                        to={item.link}
                                        onClick={handleLinkClick} // Đóng menu khi click
                                    >
                                        {item.title}
                                    </NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;